import { render, staticRenderFns } from "./UserSignatures.vue?vue&type=template&id=2b5112e8&scoped=true"
import script from "./UserSignatures.vue?vue&type=script&lang=js"
export * from "./UserSignatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5112e8",
  null
  
)

export default component.exports